import { InvoiceBillingStage } from '@features/invoices/enums/invoiceBillingStage'
import { InvoiceEventType } from '@features/invoices/enums/invoiceEventType'

import { InvoiceClarificationEventType } from '../types/invoiceClarificationEventType'

export const invoiceStatusToTranslationKey: Record<InvoiceEventType, string> = {
  [InvoiceEventType.DeliveryBaswareEinvoiceFailureEmail]:
    'external_invoices.view.sidebar.timeline.status.delivery.basware.einvoice.failure.email',
  [InvoiceEventType.DeliveryBaswareEinvoiceNotification]:
    'external_invoices.view.sidebar.timeline.status.delivery.basware.einvoice.notification',
  [InvoiceEventType.DeliveryBaswareEinvoiceSent]:
    'external_invoices.view.sidebar.timeline.status.delivery.basware.einvoice.sent',
  [InvoiceEventType.DeliveryBaswarePaperNotification]:
    'external_invoices.view.sidebar.timeline.status.delivery.basware.paper.notification',
  [InvoiceEventType.DeliveryBaswarePaperSent]:
    'external_invoices.view.sidebar.timeline.status.delivery.basware.paper.sent',
  [InvoiceEventType.DeliveryCreditnoteEmailFailureEmail]:
    'external_invoices.view.sidebar.timeline.status.delivery.creditnote.email.failure.email',
  [InvoiceEventType.DeliveryCreditnoteEmailSent]:
    'external_invoices.view.sidebar.timeline.status.delivery.creditnote.email.sent',
  [InvoiceEventType.DeliveryEmailCaptchaFailed]:
    'external_invoices.view.sidebar.timeline.status.delivery.email.captcha_failed',
  [InvoiceEventType.DeliveryEmailComplained]:
    'external_invoices.view.sidebar.timeline.status.delivery.email.complained',
  [InvoiceEventType.DeliveryEmailDelivered]: 'external_invoices.view.sidebar.timeline.status.delivery.email.delivered',
  [InvoiceEventType.DeliveryEmailDropped]: 'external_invoices.view.sidebar.timeline.status.delivery.email.dropped',
  [InvoiceEventType.DeliveryEmailEinvoiceFailedSubject]:
    'external_invoices.view.sidebar.timeline.status.delivery.email.einvoice.failed.subject',
  [InvoiceEventType.DeliveryEmailEmailFailedSubject]:
    'external_invoices.view.sidebar.timeline.status.delivery.email.email.failed.subject',
  [InvoiceEventType.DeliveryEmailFailed]: 'external_invoices.view.sidebar.timeline.status.delivery.email.failed',
  [InvoiceEventType.DeliveryEmailPaperFailedSubject]:
    'external_invoices.view.sidebar.timeline.status.delivery.email.einvoice.failed.subject',
  [InvoiceEventType.DeliveryEmailSent]: 'external_invoices.view.sidebar.timeline.status.delivery.email.sent',
  [InvoiceEventType.DeliveryInhouseEinvoiceSent]:
    'external_invoices.view.sidebar.timeline.status.delivery.inhouse.einvoice.sent',
  [InvoiceEventType.DeliveryManualSent]: 'external_invoices.view.sidebar.timeline.status.delivery.manual.sent',
  [InvoiceEventType.DeliveryManualUnsent]: 'external_invoices.view.sidebar.timeline.status.delivery.manual.unsent',
  [InvoiceEventType.DeliveryPublicDeBaswareEinvoiceNotification]:
    'external_invoices.view.sidebar.timeline.status.delivery.basware.einvoice.notification',
  [InvoiceEventType.DeliveryPublicDeBaswareEinvoiceSent]:
    'external_invoices.view.sidebar.timeline.status.delivery.basware.einvoice.sent',
  [InvoiceEventType.DeliveryPublicFrBaswareEinvoiceNotification]:
    'external_invoices.view.sidebar.timeline.status.delivery.basware.einvoice.notification',
  [InvoiceEventType.DeliveryPublicFrBaswareEinvoiceSent]:
    'external_invoices.view.sidebar.timeline.status.delivery.basware.einvoice.sent',
  [InvoiceEventType.DeliveryRecipientPortalOpened]:
    'external_invoices.view.sidebar.timeline.status.delivery.recipient-portal.opened',
  [InvoiceEventType.DeliveryReminderEmailComplained]:
    'external_invoices.view.sidebar.timeline.status.delivery.reminder.email.complained',
  [InvoiceEventType.DeliveryReminderEmailDelivered]:
    'external_invoices.view.sidebar.timeline.status.delivery.reminder.email.delivered',
  [InvoiceEventType.DeliveryReminderEmailDropped]:
    'external_invoices.view.sidebar.timeline.status.delivery.reminder.email.dropped',
  [InvoiceEventType.DeliveryReminderEmailFailed]:
    'external_invoices.view.sidebar.timeline.status.delivery.reminder.email.failed',
  [InvoiceEventType.DeliveryReminderEmailNotsent]:
    'external_invoices.view.sidebar.timeline.status.delivery.reminder.email.notsent',
  [InvoiceEventType.DocumentCreated]: 'external_invoices.view.sidebar.timeline.status.document.created',
  [InvoiceEventType.DocumentCreditNoteCreated]:
    'external_invoices.view.sidebar.timeline.status.document.creditnote.created',
  [InvoiceEventType.DocumentDeleted]: 'external_invoices.view.sidebar.timeline.status.document.deleted',
  [InvoiceEventType.DocumentIntegrationCpaToolsCreateRequestRejected]:
    'external_invoices.view.sidebar.timeline.status.document.integration.cpa_tools.create.request.rejected',
  [InvoiceEventType.DocumentIntegrationCpaToolsCreateRequestSuccess]:
    'external_invoices.view.sidebar.timeline.status.document.integration.cpa_tools.create.request.success',
  [InvoiceEventType.DocumentPdfDownloaded]: 'external_invoices.view.sidebar.timeline.status.document.pdf.downloaded',
  [InvoiceEventType.DocumentReminderEmailSent]:
    'external_invoices.view.sidebar.timeline.status.document.reminder.email.sent',
  [InvoiceEventType.DocumentReminderPostNotsent]:
    'external_invoices.view.sidebar.timeline.status.document.reminder.post.notsent',
  [InvoiceEventType.DocumentReminderPostSent]:
    'external_invoices.view.sidebar.timeline.status.document.reminder.post.sent',
  [InvoiceEventType.FileZugferdGenerated]:
    'external_invoices.view.sidebar.timeline.status.document.generation.zugferd.generated',
}

export const creditNoteStatusToTranslationKey: Partial<Record<InvoiceEventType, string>> = {
  [InvoiceEventType.DeliveryBaswareEinvoiceSent]:
    'external_invoices.view.sidebar.timeline.status.delivery.basware.einvoice.sent.creditnote',
  [InvoiceEventType.DeliveryEmailSent]: 'external_invoices.view.sidebar.timeline.status.delivery.email.sent.creditnote',
  [InvoiceEventType.DeliveryManualSent]:
    'external_invoices.view.sidebar.timeline.status.delivery.manual.sent.creditnote',
  [InvoiceEventType.DeliveryManualUnsent]:
    'external_invoices.view.sidebar.timeline.status.delivery.manual.unsent.creditnote',
  [InvoiceEventType.DeliveryRecipientPortalOpened]:
    'external_invoices.view.sidebar.timeline.status.delivery.recipient-portal.opened.creditnote',
  [InvoiceEventType.DocumentCreated]: 'external_invoices.view.sidebar.timeline.status.document.created.creditnote',
  [InvoiceEventType.DocumentPdfDownloaded]:
    'external_invoices.view.sidebar.timeline.status.document.pdf.downloaded.creditnote',
}

export const invoiceStatusClarificationToTranslationKey: Record<InvoiceClarificationEventType, string> = {
  [InvoiceEventType.DeliveryEmailComplained]:
    'external_invoices.view.sidebar.timeline.status.delivery.email.complained.clarification',
  [InvoiceEventType.DeliveryEmailFailed]:
    'external_invoices.view.sidebar.timeline.status.delivery.email.failed.clarification',
  [InvoiceEventType.DeliveryReminderEmailNotsent]:
    'external_invoices.view.sidebar.timeline.status.delivery.reminder.email.notsent.clarification',
  [InvoiceEventType.DocumentReminderPostNotsent]:
    'external_invoices.view.sidebar.timeline.status.document.reminder.post.notsent.clarification',
  [InvoiceEventType.DeliveryBaswareEinvoiceFailureEmail]:
    'external_invoices.view.sidebar.timeline.status.delivery.basware.einvoice.failure.email.clarification',
}

export const invoiceBillingStageStatusToTranslationKey: Record<
  InvoiceBillingStage,
  Partial<Record<InvoiceEventType, string>>
> = {
  [InvoiceBillingStage.Deposit]: {
    [InvoiceEventType.DocumentCreated]:
      'external_invoices.view.sidebar.timeline.status.document.created.deposit_invoice',
    [InvoiceEventType.DocumentDeleted]:
      'external_invoices.view.sidebar.timeline.status.document.deleted.deposit_invoice',
    [InvoiceEventType.DocumentPdfDownloaded]:
      'external_invoices.view.sidebar.timeline.status.document.pdf.downloaded.deposit_invoice',
    [InvoiceEventType.DeliveryManualSent]:
      'external_invoices.view.sidebar.timeline.status.delivery.manual.sent.deposit_invoice',
    [InvoiceEventType.DeliveryManualUnsent]:
      'external_invoices.view.sidebar.timeline.status.delivery.manual.unsent.deposit_invoice',
    [InvoiceEventType.DeliveryEmailSent]:
      'external_invoices.view.sidebar.timeline.status.delivery.email.sent.deposit_invoice',
  },
  [InvoiceBillingStage.Final]: {
    [InvoiceEventType.DocumentCreated]: 'external_invoices.view.sidebar.timeline.status.document.created.final_invoice',
    [InvoiceEventType.DocumentDeleted]: 'external_invoices.view.sidebar.timeline.status.document.deleted.final_invoice',
    [InvoiceEventType.DocumentPdfDownloaded]:
      'external_invoices.view.sidebar.timeline.status.document.pdf.downloaded.final_invoice',
    [InvoiceEventType.DeliveryManualSent]:
      'external_invoices.view.sidebar.timeline.status.delivery.manual.sent.final_invoice',
    [InvoiceEventType.DeliveryManualUnsent]:
      'external_invoices.view.sidebar.timeline.status.delivery.manual.unsent.final_invoice',
    [InvoiceEventType.DeliveryEmailSent]:
      'external_invoices.view.sidebar.timeline.status.delivery.email.sent.final_invoice',
  },
}
